import {
  Action,
  ActionType,
  DownloadBusinessUserCSVResponse,
} from "models/userListBusiness/downloadBusinessUserCSV";

import createReducer from "../../createReducer";

export interface DownloadBusinessUserCSVReducerType {
  loading: boolean;
  error?: string;
  downloadBusinessUserCSVResponse?: DownloadBusinessUserCSVResponse;
}

const defaultState: DownloadBusinessUserCSVReducerType = {
  loading: false,
  error: undefined,
  downloadBusinessUserCSVResponse: undefined,
};

export const downloadBusinessUserCSVReducer =
  createReducer<DownloadBusinessUserCSVReducerType>(defaultState, {
    [ActionType.DOWNLOAD_BUSINESS_USER_CSV](
      state: DownloadBusinessUserCSVReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.DOWNLOAD_BUSINESS_USER_CSV_ERROR](
      state: DownloadBusinessUserCSVReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.DOWNLOAD_BUSINESS_USER_CSV_SUCCESS](
      state: DownloadBusinessUserCSVReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        downloadBusinessUserCSVResponse: action.payload,
      };
    },

    [ActionType.DOWNLOAD_BUSINESS_USER_CSV_RESET_DATA](
      state: DownloadBusinessUserCSVReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        downloadBusinessUserCSVResponse: undefined,
      };
    },
  });
